import type { MouseEvent } from 'react';

type Props = {
  selectedFields: string[];
  templatePlaceholders: Record<string, string>;
  activeInputId: string | null;
  onChipMouseDown: (e: MouseEvent) => void;
  onFieldInsert: (field: string) => void;
};

export function FieldPalette({
  selectedFields, templatePlaceholders, activeInputId, onChipMouseDown, onFieldInsert,
}: Props) {
  const templatePlaceholderKeys = Object.keys(templatePlaceholders).filter(k => k.trim());

  return (
    <div className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-border/50 bg-muted/20 flex-wrap mb-4">
      <span className="text-[10px] font-mono text-muted-foreground/60 uppercase tracking-widest mr-1 shrink-0">fields:</span>
      {selectedFields.length === 0 && templatePlaceholderKeys.length === 0 ? (
        <span className="text-xs text-muted-foreground/50 italic">No fields selected — go to Campaign tab first</span>
      ) : (
        <>
          {selectedFields.map(field => (
            <button
              key={field}
              className={`font-mono text-[11px] px-1.5 py-0.5 rounded border transition-all select-none ${
                activeInputId
                  ? 'bg-primary/10 border-primary/30 text-primary hover:bg-primary/20 cursor-pointer'
                  : 'bg-muted/50 border-border/40 text-muted-foreground/60 cursor-default'
              }`}
              onMouseDown={onChipMouseDown}
              onClick={() => onFieldInsert(field)}
            >
              {'{' + field.replace('custom:', '') + '}'}
            </button>
          ))}
          {templatePlaceholderKeys.map(key => (
            <button
              key={`tp_${key}`}
              className={`font-mono text-[11px] px-1.5 py-0.5 rounded border transition-all select-none ${
                activeInputId
                  ? 'bg-violet-500/10 border-violet-500/30 text-violet-600 dark:text-violet-400 hover:bg-violet-500/20 cursor-pointer'
                  : 'bg-muted/50 border-border/40 text-muted-foreground/60 cursor-default'
              }`}
              onMouseDown={onChipMouseDown}
              onClick={() => onFieldInsert(key)}
              title={`Template placeholder: ${templatePlaceholders[key] ?? ''}`}
            >
              {`{${key}}`}
            </button>
          ))}
        </>
      )}
      {!activeInputId && (selectedFields.length > 0 || templatePlaceholderKeys.length > 0) && (
        <span className="text-[10px] text-muted-foreground/35 italic ml-1">— click an input to activate</span>
      )}
    </div>
  );
}
